import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { JsonService } from '../_services/json.service';
import { LoggerService } from '../_services/logger.service';
import { LoadingService } from '../_services/loading.service';

@Component({
  selector: 'app-monitoramento-processos',
  templateUrl: './monitoramento-processos.component.html',
  styleUrls: ['./monitoramento-processos.component.scss']
})
export class MonitoramentoProcessosComponent implements OnInit, OnDestroy {
  listaLinhas: any[] = [];
  atualizadoEm: string | null = null;
  listaPaises: any[] = [];

  filtro: any = { pais: '', processo: '', status: '', intervaloMin: 10 };

  private refreshHandle: any;

  constructor(
    private jsonService: JsonService,
    private logger: LoggerService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.restoreFiltro();
    this.jsonService.listCountry().subscribe({
      next: paises => this.listaPaises = paises,
      error: err => this.logger.error('Erro ao carregar países', err)
    });
    this.consultar();
    this.reiniciarAutoRefresh();
  }

  ngOnDestroy(): void {
    clearInterval(this.refreshHandle);
  }

  private restoreFiltro(): void {
    const saved = localStorage.getItem('filtroMonitoramento');
    if (saved) this.filtro = JSON.parse(saved);
  }

  // Intervalo de atualização é preferência de quem está com a tela aberta, não configuração de
  // sistema — guardado junto do resto do filtro, mesmo padrão de localStorage já usado no projeto.
  reiniciarAutoRefresh(): void {
    clearInterval(this.refreshHandle);
    const ms = Number(this.filtro.intervaloMin) * 60_000;
    this.refreshHandle = setInterval(() => this.consultar(), ms);
  }

  private buildFilterParams(): HttpParams {
    let p = new HttpParams();
    if (this.filtro.pais) p = p.append('pais', this.filtro.pais);
    if (this.filtro.processo) p = p.append('processo', this.filtro.processo);
    if (this.filtro.status) p = p.append('status', this.filtro.status);
    return p;
  }

  consultar(): void {
    localStorage.setItem('filtroMonitoramento', JSON.stringify(this.filtro));
    this.loadingService.show();
    this.jsonService.getMonitoramentoProcessos(this.buildFilterParams()).subscribe({
      next: resp => {
        this.listaLinhas = resp.linhas;
        this.atualizadoEm = resp.atualizadoEm;
        this.loadingService.hide();
      },
      error: err => {
        this.logger.error('Erro ao carregar monitoramento de processos', err);
        this.loadingService.hide();
      }
    });
  }

  limparFiltro(): void {
    this.filtro = { pais: '', processo: '', status: '', intervaloMin: this.filtro.intervaloMin };
    this.consultar();
  }

  statusClass(status: string): string {
    return ({ Rodando: 'completed', Ocioso: 'pending', Travado: 'red-bold', Erro: 'red-bold' } as any)[status] ?? '';
  }
}
